import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowRight } from '@phosphor-icons/react'
import { parseISO } from 'date-fns/esm'

import { formatPhoneNumber } from '@/cart/utils/formatPhoneNumber'

import { useAppContext } from '@/main/app/context'
import { useCart } from './SidebarCartLayout'
import { ListResetDialog } from '@/main/features/List/components/ListDialogs/ListResetDialog/ListResetDialog'
import { formatShortDate } from '@/main/app/utils/dates'

import { DeliveryValues } from '../Form/DeliveryValues/DeliveryValues'

export function SidebarCartIndex() {
  const {
    formPaths: [step1, step2],
  } = useAppContext()

  const { list } = useCart()

  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const startsOn = list?.form?.dates?.values.startDate
    ? formatShortDate(parseISO(list.form.dates?.values.startDate))
    : undefined
  const endsOn = list?.form?.dates?.values.endDate
    ? formatShortDate(parseISO(list.form.dates?.values.endDate))
    : undefined

  return !list || !list.history ? (
    <div className="twc-bg-slate-100 twc-shadow-lg twc-p-6 twc-prose dark:twc-prose-invert dark:twc-bg-slate-900 twc-rounded twc-prose-sm 2xl:twc-prose-base">
      <h3>Get started and check availability</h3>
      <p>
        Add props and info to a project, then submit your cart to send it to ACME. We will check
        availability and e-mail you a quote.
      </p>
      <p>
        <strong>
          <em>No payment is needed to submit your cart.</em>
        </strong>{' '}
        This is not an order form, and there is no cost to place props on hold.
      </p>
      <Link
        className="twc-flex-shrink-0 twc-inline-flex twc-items-center twc-gap-1"
        to={list?.id ? `/${list.id}/form/${step1}` : ''}
      >
        Start New Request <ArrowRight />
      </Link>
    </div>
  ) : (
    <div className="twc-flex twc-flex-wrap twc-w-full twc-gap-4">
      <div className="twc-border twc-grow twc-shrink twc-basis-full sm:twc-basis-[48%] xl:twc-basis-full twc-max-w-3xl twc-rounded twc-p-4 twc-border-gray-100 dark:twc-border-gray-800 twc-shadow twc-bg-white dark:twc-bg-slate-800/40 twc-prose-sm prose-h3:twc-my-0">
        <div className="twc-flex twc-justify-between twc-items-center twc-flex-wrap">
          <h3 className="twc-mb-0 twc-font-semibold twc-grow-[999] twc-w-[89%]">
            Contact &amp; Project Info
          </h3>
          <Link className="twc-shrink-0 twc-grow-0" to={`/${list.id}/form/${step1}`}>
            Edit &raquo;
          </Link>
        </div>
        <p>
          Contact: {list.form?.profile?.values.firstName} {list.form?.profile?.values.lastName}
          <br />
          Email: {list.form?.profile?.values.email}
          <br />
          Phone:{' '}
          {list.form?.profile?.values.phone && formatPhoneNumber(list.form?.profile?.values.phone)}
        </p>
        <p>
          Client: {list.form?.billing?.values.client}
          <br />
          Project/Job Reference: {list.form?.billing?.values.reference}
        </p>
      </div>
      <div className="twc-border twc-grow twc-shrink twc-basis-full sm:twc-basis-[48%] xl:twc-basis-full twc-rounded twc-p-4 twc-border-gray-100 dark:twc-border-gray-800 twc-shadow twc-bg-white dark:twc-bg-slate-800/50 twc-max-w-3xl twc-prose-sm prose-h3:twc-mt-0">
        <div className="twc-flex twc-justify-between twc-items-center twc-flex-wrap">
          <h3 className="twc-mb-0 twc-font-semibold twc-grow-[999] twc-w-[89%]">
            Rental Dates &amp;{' '}
            {list.form?.shipping?.values.shippingMethod === 'delivery'
              ? 'Delivery'
              : 'Pick-up/Return'}{' '}
            Info
          </h3>

          <Link className="twc-shrink-0 twc-grow-0" to={`/${list.id}/form/${step2}`}>
            Edit &raquo;
          </Link>
        </div>

        {startsOn && endsOn && (
          <p>
            Start Date: {startsOn}
            <br />
            End Date: {endsOn}
          </p>
        )}

        {list.form?.shipping?.values.shippingMethod === 'pickup' ? (
          <p>
            Pick-up &amp; Return:
            <br />
            ACME Brooklyn
            <br />
            350 Meserole Street, Building D<br />
            Brooklyn, NY 11206
          </p>
        ) : list.form?.shipping?.values.shippingMethod === 'delivery' &&
          list.form.shipping.values.shippingDetail ? (
          <DeliveryValues values={list.form.shipping.values.shippingDetail} />
        ) : null}
      </div>

      <ListResetDialog
        listId={list.id}
        isOpen={searchParams.get('dialog') === 'reset'}
        onClose={(goToStep1?: boolean) => {
          setSearchParams({})
          if (goToStep1) {
            navigate(`/${list.id}/form/${step1}`)
          }
        }}
      />
    </div>
  )
}
